import { createSlice } from '@reduxjs/toolkit';

export interface UserActivity {
  isActive: boolean;
}

export const UserActivityState = createSlice({
  name: 'UserActivityReducer',
  initialState: {
    isActive: true,
  },
  reducers: {
    setActive: (mutableState) => {
      mutableState.isActive = true;
    },
    setInactive: (mutableState) => {
      mutableState.isActive = false;
    },
  },
});

export const { setActive, setInactive } = UserActivityState.actions;
